// import React from 'react'
// // import logo from '../assets/images/main-logo.svg'
// import logo from '../assets/images/asap_logo.png'
// import arrowclose from '../assets/images/collapsed-arrows-left.svg'
// import arrowopen from '../assets/images/collapsed-arrows-right.svg'
// import routes from '../routes/routes'
// import { NavLink, useLocation } from 'react-router-dom'
// import { Tooltip } from 'antd'
// import { ACL_ROUTE } from "../utils/constant";
// import { useSelector } from 'react-redux'
// import { use } from 'react'
// import { Button } from '@mui/material'
// import { useDispatch } from "react-redux";
// import { singleSignonService } from "../store/Authentication/AuthSlice";
// import axios from 'axios'


// const Sidebar = ({ open, setOpen }) => {
//     let path = useLocation();
//     const dispatch = useDispatch();

//     //const userRole = useSelector((state)=>state.userlogin.logedUser?.userroles)
//     // const role=localStorage.getItem('user')
//     // console.log("role",role)
//     const data = useSelector((state) => state?.data?.data?.data?.user?.userroles);
//     const pathArray = path.pathname.split('/')
//     const getAuthorizedRoutes = routes.filter((route) => ACL_ROUTE[data]?.includes(route.path));
//     console.log("getAuthorizedRoutes", typeof getAuthorizedRoutes, getAuthorizedRoutes)
    
//     return (
//         <aside className={` h-full fixed pb-10 rounded-xl transition-all duration-[0.5s] ease-in delay-[0s] ${open ? 'w-[260px]' : 'w-[80px]'}`} aria-label="Sidebar">
//             <div className="overflow-y-auto h-full bg-white rounded-xl shadow-sidebarbox">
//                 <div className={`${open ? 'p-5' : 'p-0 my-5'}`}>
//                     <div className={`flex items-center justify-between ${open ? 'flex-col' : 'flex-col'}`}>
//                         <div className="w-100">
//                             <img src={logo} alt="SGATE" className={`cursor-pointer my-2 logoSidebar`} />
//                         </div>
//                         <div className="w-100">
//                             <button type="button" className="flex text-white cursor-pointer my-2" onClick={() => setOpen(!open)}>
//                                 <img src={open ? arrowclose : arrowopen} alt="Collapse Arrow" />
//                             </button>
//                         </div>
//                     </div>

//                 </div>
//                 <hr className='border-[#F5F5F5]' />
//                 <ul className="space-y-2 my-5">
//                     {
//                         getAuthorizedRoutes.map((menu, index) => {
//                             return (
//                                 <li key={index}>
//                                     <Tooltip title={menu.name} placement="right" trigger={!open ? "hover" : ''} color='#FFAF00'>
//                                         <NavLink to={menu.path} className={`flex items-center py-3 px-5 text-sm font-semibold hover:bg-white relative bg-white ${pathArray[1] === menu.path ? 'after:content-[""] after:w-0 after:h-0 after:border-[15px] after:border-solid after:border-transparent after:top-0 after:bottom-0 after:margin-auto after:right-0 after:border-r-primary after:border-t-[25px] after:border-b-[22px] after:absolute text-primary shadow-avtivemenu' : 'text-secondary'}`}>
//                                             <img style={{ width: "20px", height: "20px" }} src={pathArray[1] === menu.path ? menu.menuiconActive : menu.menuicon} alt={menu.name} />
//                                             <span className={`${open ? 'block mx-4' : 'hidden'}`}>{menu.name}</span>
//                                         </NavLink>
//                                     </Tooltip>
//                                 </li>
//                             )
//                         })
//                     }
//                 </ul>
//             </div>
//         </aside>
//     )
// }

// export default Sidebar


import React from 'react'
// import logo from '../assets/images/main-logo.svg'
import logo from '../assets/images/asap_logo.png'
import arrowclose from '../assets/images/collapsed-arrows-left.svg'
import arrowopen from '../assets/images/collapsed-arrows-right.svg'
import routes from '../routes/routes'
import { NavLink, useLocation } from 'react-router-dom'
import { Tooltip } from 'antd'
import { ACL_ROUTE } from "../utils/constant";
import { useSelector } from 'react-redux'
import { Button } from '@mui/material'
import { useDispatch } from "react-redux";
import { authuser, singleSignonService } from "../store/Authentication/AuthSlice";
import axios from 'axios'


const Sidebar = ({ open, setOpen }) => {
    let path = useLocation();
    const dispatch = useDispatch();

    const userrole = useSelector(authuser);
    const data = useSelector((state) => state?.data?.data?.data?.user?.userroles);
    const pathArray = path.pathname.split('/')
    const getAuthorizedRoutes = routes.filter((route) => ACL_ROUTE[data]?.includes(route.path));
    console.log("getAuthorizedRoutes", typeof getAuthorizedRoutes, getAuthorizedRoutes)

    return (
        <>

    { userrole?.userroles !="customer_admin"&&  userrole?.userroles !="customer"&&userrole?.userroles !="kam"&&(
        <aside className={`h-full fixed pb-0 rounded-xl transition-all duration-[0.5s] ease-in delay-[0s] ${open ? 'w-[260px]' : 'w-[80px]'}`} aria-label="Sidebar">
            <div className="overflow-y-auto h-full bg-white rounded-xl shadow-sidebarbox">
                <div className={`${open ? 'p-5' : 'p-0 my-5'}`}>
                    <div className={`flex items-center justify-between ${open ? 'flex-col' : 'flex-col'}`}>
                        <div className="w-100">
                            <img src={logo} alt="SGATE" className={`cursor-pointer my-2 logoSidebar`} />
                        </div>
                        <div className="w-100">
                            <button type="button" className="flex text-white cursor-pointer my-2" onClick={() => setOpen(!open)}>
                                <img src={open ? arrowclose : arrowopen} alt="Collapse Arrow" />
                            </button>
                        </div>
                    </div>

                </div>
                <hr className='border-[#F5F5F5]' />
                <ul className="space-y-2 my-5">
                    {
                        getAuthorizedRoutes.map((menu, index) => {
                            return (
                                <li key={index}>
                                    <Tooltip title={menu.name} placement="right" trigger={!open ? "hover" : ''} color='#FFAF00'>
                                        <NavLink to={menu.path} className={`flex items-center py-3 px-5 text-sm font-semibold hover:bg-white relative bg-white ${pathArray[1] === menu.path ? 'after:content-[""] after:w-0 after:h-0 after:border-[15px] after:border-solid after:border-transparent after:top-0 after:bottom-0 after:margin-auto after:right-0 after:border-r-primary after:border-t-[25px] after:border-b-[22px] after:absolute text-primary shadow-avtivemenu' : 'text-secondary'}`}>
                                            <img style={{ width: "20px", height: "20px" }} src={pathArray[1] === menu.path ? menu.menuiconActive : menu.menuicon} alt={menu.name} />
                                            <span className={`${open ? 'block mx-4' : 'hidden'}`}>{menu.name}</span>
                                        </NavLink>
                                    </Tooltip>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </aside>)}
        </>
    )
}

export default Sidebar
